import { useState, useContext } from "react";
import "./header.css";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { AuthContext } from "../../Contexts/AuthContext";
import { CgProfile } from "react-icons/cg";
import { AiTwotoneDashboard } from "react-icons/ai";
import { PiCowFill } from "react-icons/pi";
import { IoIosAddCircleOutline } from "react-icons/io";
import { LuListTodo } from "react-icons/lu";
import { FaUsersCog } from "react-icons/fa";


export default function Header() {
  const { user, logout } = useContext(AuthContext);
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    logout();
    setOpen(false);
    navigate("/"); 
  };
  const onClickLink = () => {
    setTimeout(() => setOpen(false), 300);
  }

  const isActive = (path) => location.pathname === path;

  const adminMenu = (
    <>
      <Link className={isActive("/admin") ? "active" : ""} onClick={onClickLink} to="/admin"><AiTwotoneDashboard /> Accueil</Link>
      <Link className={isActive("/admin/animals") ? "active" : ""} onClick={onClickLink} to="/admin/animals"><PiCowFill /> Animaux</Link>
      <Link className={isActive("/admin/to-do") ? "active" : ""} onClick={onClickLink} to="/admin/to-do"><LuListTodo /> To-do</Link>
      <Link className={isActive("/admin/manage-users") ? "active" : ""} onClick={onClickLink} to="/admin/manage-users"><FaUsersCog /> Gérer utilisateurs</Link>
      <Link className={isActive("/admin/reproduction") ? "active" : ""} onClick={onClickLink} to="/admin/reproduction">Reproduction</Link>
      <Link className={isActive("/admin/croissance") ? "active" : ""} onClick={onClickLink} to="/admin/croissance">Croissance</Link>

    </>
  );

  const eleveurMenu = (
    <>
      <Link className={isActive("/eleveur/profile") ? "active" : ""} onClick={onClickLink} to="/eleveur/profile"><CgProfile /></Link>
      <Link className={isActive("/eleveur") ? "active" : ""} onClick={onClickLink} to="/eleveur"><AiTwotoneDashboard /> Accueil</Link>
      <Link className={isActive("/eleveur/animals") ? "active" : ""} onClick={onClickLink} to="/eleveur/animals"><PiCowFill /> Mes Animaux</Link>
      <Link className={isActive("/eleveur/add-animal") ? "active" : ""} onClick={onClickLink} to="/eleveur/add-animal"><IoIosAddCircleOutline /> Ajouter animal</Link>
      <Link className={isActive("/eleveur/to-do") ? "active" : ""} onClick={onClickLink} to="/eleveur/to-do"><LuListTodo /> To-do</Link>
      <Link className={isActive("/eleveur/reproduction") ? "active" : ""} onClick={onClickLink} to="/eleveur/reproduction">Reproduction</Link>
      <Link className={isActive("/eleveur/croissance") ? "active" : ""} onClick={onClickLink} to="/eleveur/croissance">Croissance</Link>
    </>
  );
  const navLanding = (
    <>
      <a href="#features">Fonctionnalités</a>
      <a href="#how-it-works">Comment ça marche</a>
      <a href="#benefits">Avantages</a>
      <button
        className="nav-btn login-btn"
        onClick={() => navigate('/signin')}
      >
        Se connecter
      </button>
      <button
        className="nav-btn signup-btn"
        onClick={() => navigate('/signup')}
      >
        Commencer
      </button>
    </>
  );

  return (
    <header className="header">
      <div className="logo"><a href={"/" + user?.role}>Roue de reproduction</a></div>


      <nav className="nav">
        {isActive('/') && navLanding}
        {(user?.role === "admin" && !isActive('/')) && adminMenu}
        {(user?.role === "eleveur" && !isActive('/')) && eleveurMenu}

        {user && <button onClick={handleLogout} className="logout">Logout</button>}
      </nav>

      <button className="menu-btn" onClick={() => setOpen(!open)}>
        ☰
      </button>

      {open && (
        <div className="mobile-menu">
          {isActive('/') && navLanding}
          {(user?.role === "admin" && !isActive('/')) && adminMenu}
          {(user?.role === "eleveur" && !isActive('/')) && eleveurMenu}

          {(user && !isActive('/')) && <button onClick={handleLogout} className="logout">Logout</button>}
        </div>
      )}
    </header>
  );
}